import { render, staticRenderFns } from "./FarmFireRiskChartTooltip.factory.vue?vue&type=template&id=2e7385c4"
import script from "./FarmFireRiskChartTooltip.factory.vue?vue&type=script&lang=ts&setup=true"
export * from "./FarmFireRiskChartTooltip.factory.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports